import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// styles
import styles from './PdpRespHeroCarousel.scss';

// helpers
import get from 'lodash.get';

export function PdpRespHeroCarouselPrintComponent(props) {
    return (
        <div className={styles.printCarousel}>
            <img className={styles.printImage} src={get(props, 'item.photos[0].largePath')} />
        </div>
    );
}

PdpRespHeroCarouselPrintComponent.propTypes = {
    item: PropTypes.object.isRequired,
};

export const PdpRespHeroCarouselPrint = createFragmentContainer(PdpRespHeroCarouselPrintComponent, {
    item: graphql`
        fragment PdpRespHeroCarouselPrint_item on Item {
            photos {
                largePath
            }
        }
    `,
});
